import type { ComponentProps } from 'react';

import clsx from 'clsx';

import OriginalIcon from '~/src/common/components/Icon';

import styles from './Menu.module.scss';

type Props = ComponentProps<typeof OriginalIcon>;

const Icon = ({ className, ...rest }: Props) => {
  return <OriginalIcon className={clsx(styles.icon, className)} {...rest} />;
};

export default Icon;
